import React from 'react'
import { MuiGrid, } from '../../../ui/MaterialUIComponents';

import { getTimeTableSlots, getTimeTableSlotsForTeacher, getTimeTableSlotsForAvailableTeacher } from './TimeTableCalenderUtil'
import DayComponent from '../../Calender/DayComponent'
export default function IndividualTimeTableGrid(props) {
  let calendar = []
  if (props.timeTableType == 'forTeacher') {
    if (props.availableTeachers) {
      calendar = getTimeTableSlotsForAvailableTeacher(props.classItem, props.startHourSlot, props.lastHourSlot)
    }
    else {
      calendar = getTimeTableSlotsForTeacher(props.classItem, props.header, props.startHourSlot, props.lastHourSlot)
    }
  } else {
    calendar = getTimeTableSlots(props.classItem, props.startHourSlot, props.lastHourSlot)

  }

  function filterTimeSlots(day) {
    let timeSlots = day.timeSlots
    day.timeSlots = timeSlots.filter((slot) => ((slot.timeBlock >= props.startHourSlot) && (slot.timeBlock <= (props.lastHourSlot))))
    return day
  }
  return (
    <MuiGrid container >
      {calendar.length > 0 && calendar.map((day, index) => (
        <MuiGrid key={index} item xs>
          <DayComponent day={filterTimeSlots(day)} viewTimeTable={true} cellHeight={3}
            {...props} />
        </MuiGrid>
      ))}
    </MuiGrid>
  )
}